import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {
  SHOP_LOCALE,
  TRANSLATIONS
} from '../../../utils/configure-environment';

Vue.use(VueI18n);

export default new VueI18n({
  locale: SHOP_LOCALE,
  messages: {
    [SHOP_LOCALE]: TRANSLATIONS
  },
  silentTranslationWarn: true
});
